<div class='acc-cohort-tab1-part'>
	@if(acc(); as acc){
	<div>
		<h5>Cohort Google Meet</h5>
		<common-button-row [center]="true">
			@if(isAnyEventMissingCalendarId()){
			<button class="btn btn-standard" (click)="generateClassEvents()">Generate Class Events</button>
			}
			<button class="btn btn-standard" (click)="openCohortMeetCodeEditor()">{{cohortMeetButtonText()}}</button>
			@if(acc.googleMeetCode){
			<button class="btn btn-standard" (click)="openGoogleMeet(acc.googleMeetCode)">Open Google Meet</button>
			}
			@if(anyEventsWithCalendarId()){
			<button class="btn btn-standard" (click)="updateClassAttendees()">Update Class Attendees</button>
			}
		</common-button-row>
	</div>

	<div class="mt-5">
		<h5>Facilitator Office Hours Link</h5>

		<common-button-row [center]="true">
			<button class="btn btn-standard" (click)="openFacilitatorScheduleLinkEditor()">{{officeHoursButtonText()}}</button>
			@if(acc.facilitator.scheduleLink){
			<button class="btn btn-standard" (click)="openURL(acc.facilitator.scheduleLink)">Open Link</button>
			}
		</common-button-row>
	</div>

	<div class="mt-5">
		<h5>Cohort Google Groups</h5>

		@if(acc.areGoogleGroupsCreated) {
		<div>
			<p class="mb-2">Entrepreneur Group: <link-button [link]="getGroupLink(acc.entGoogleGroup, acc.languageId)"></link-button></p>
			@if(acc.hasMentors){
			<p>Mentor Group: <link-button [link]="getGroupLink(acc.mentorGoogleGroup, acc.languageId)"></link-button></p>
			}
		</div>

		} @else {
		@if(acc.status === 'In-Cohort'){
		<common-button-row [center]="true">
			<button class="btn btn-standard" (click)="createGoogleGroups(acc.accId)">Create Groups</button>
		</common-button-row>
		} @else if (acc.status === 'Upcoming') {
		<p>Groups can be added after Team Matching.</p>
		} @else {
		<p>No groups available.</p>
		}
		}

	</div>
	}
</div>